import request from '@/utils/request';
import { toISOString } from '@/utils/date';

function transformItem2Dto(item) {
  const dto = {
    transportOrderID: item.id,
    ...item,
    shipmentAt: toISOString(item.shipmentAt)
  };
  delete dto.id;
  delete dto.exportedAt;
  delete item.workshopNames;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.transportOrderID
  };
  item.workshopNames = dto.workshopNames && dto.workshopNames.join(', ');
  delete item.transportOrderID;
  return item;
}

function getScannedOrders(params) {
  return request({
    method: 'get',
    url: 'transport-order/scannedorders',
    params: {
      ...params
    }
  });
}

function createShipments(params) {
  return request({
    method: 'post',
    url: 'transport-order/createShipmentsForScannedOrders',
    data: {
      ...params
    },
    timeout: 120000
  });
}

function exportShipments(exportShipmentsCommand) {
  const url = `transport-order/exportShipments`;
  return request({
    data: exportShipmentsCommand,
    method: 'post',
    url: url,
    timeout: 120000
  });
}

function exportShipmentsToBlackHole(exportShipmentsCommand) {
  const url = `transport-order/exportShipmentsToBlackHole`;
  return request({
    data: exportShipmentsCommand,
    method: 'post',
    url: url,
    timeout: 120000
  });
}

function updateOrderLineDeliveryDate(id, deliveryDate) {
  return request({
    data: {
      actualDeliveryDate: deliveryDate
    },
    method: 'patch',
    url: `transport-order/${id}/order-lines/actual-delivery-date`
  });
}

export const storeExtensions = {
  actions: {
    getScannedOrders({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        getScannedOrders(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    createShipments({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        createShipments(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    exportShipments({ commit, dispatch }, exportShipmentsCommand) {
      return new Promise((resolve, reject) =>
        exportShipments(exportShipmentsCommand)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    exportShipmentsToBlackHole({ commit, dispatch }, exportShipmentsCommand) {
      return new Promise((resolve, reject) =>
        exportShipmentsToBlackHole(exportShipmentsCommand)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    updateOrderLineDeliveryDate({ commit, dispatch }, { id, deliveryDate }) {
      return new Promise((resolve, reject) =>
        updateOrderLineDeliveryDate(id, deliveryDate)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};

export const apiOverrides = { transformItem2Dto, transformDto2Item };
